var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElevator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  d: "m20.5 27.196-3.115-3.087M23.615 24.11 20.5 27.196M20.5 14.11l3.115 3.086M17.385 17.195 20.5 14.11M27.5 29.5a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2v-18a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v18zM13.5 20.5h14"
}))));
export default SvgElevator;